/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * HyusnSu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Apr 23 2023
 **/

import { HTMLAttributes, PointerEvent, ReactNode } from "react";
import { ModalBody, ModalPosition } from "./private/emotion";

export type ModalProps = {
	width?: DesignStuff.Modal.Dimensions;
	height?: DesignStuff.Modal.Dimensions;
	radius?: DesignStuff.Modal.Dimensions;
	children?: ReactNode;
	preventHideByDimmed?: boolean;
	hide(): void;
};

export default function Modal({
	preventHideByDimmed = false,
	hide,
	width = "auto",
	height = "auto",
	radius = "10px",
	children,
	...rest
}: ModalProps & HTMLAttributes<HTMLDivElement>) {
	const handle_point_down = (ev: PointerEvent<HTMLDivElement>) => {
		ev.stopPropagation();
		const target = ev.target as HTMLDivElement;
		target.setPointerCapture(ev.pointerId);
	};

	const handle_point_up = (ev: PointerEvent<HTMLDivElement>) => {
		ev.stopPropagation();
		const target = ev.target as HTMLDivElement;
		target.releasePointerCapture(ev.pointerId);
	};

	return (
		<div
			className="dimmed"
			css={ModalPosition}
			onPointerDown={handle_point_up}
			onClick={() => {
				if (!preventHideByDimmed) {
					hide();
				}
			}}
		>
			<div
				className="body"
				css={ModalBody(width, height, radius)}
				onPointerDown={handle_point_down}
				onPointerUp={handle_point_up}
				{...rest}
				onClick={(e) => e.stopPropagation()}
			>
				{children}
			</div>
		</div>
	);
}
